import { InjectionToken } from '@angular/core';

/** Absolute base path of the current flow (e.g. `/onboarding`, `/upsell/energy`); see `provideFlowNavigation`. */
export const FLOW_BASE_PATH = new InjectionToken<string>('FLOW_BASE_PATH');
